import ShareApi from "./share";

class PlatformApi {
  readonly share = new ShareApi();
}

export default new PlatformApi();
